import { useQuery, gql, ApolloError } from '@apollo/client'
import {
  EmployeeDisplayShortInfoByReviewerOrBusinessUnitManagerOrCompanyManagerQuery,
  EmployeeDisplayShortInfoByReviewerOrBusinessUnitManagerOrCompanyManagerQueryVariables,
} from '../../../types'
import employeeDisplayShortInfoFragment from '../fragments/employeeDisplayShortInfo.fragment'

export const EMPLOYEE_DISPLAY_SHORT_INFO_BY_REVIEWER_OR_BUSINESS_UNIT_MANAGER_OR_COMPANY_MANAGER = gql`
  query EmployeeDisplayShortInfoByReviewerOrBusinessUnitManagerOrCompanyManager {
    employeeDisplayShortInfoByReviewerOrBusinessUnitManagerOrCompanyManager {
      employees {
        ...EmployeeDisplayShortInfo
      }
      queriedBy
    }
  }
  ${employeeDisplayShortInfoFragment}
`

export default (): {
  data: EmployeeDisplayShortInfoByReviewerOrBusinessUnitManagerOrCompanyManagerQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, error, loading } = useQuery<
    EmployeeDisplayShortInfoByReviewerOrBusinessUnitManagerOrCompanyManagerQuery,
    EmployeeDisplayShortInfoByReviewerOrBusinessUnitManagerOrCompanyManagerQueryVariables
  >(EMPLOYEE_DISPLAY_SHORT_INFO_BY_REVIEWER_OR_BUSINESS_UNIT_MANAGER_OR_COMPANY_MANAGER)

  return { data, error, loading }
}
